import axios from 'axios';

/**
 * Create a global API instance with common defaults
 */
const api = axios.create({
  baseURL: `${process.env.VUE_APP_API_BASE_URL}`,
  headers: {
    'Content-Type': 'application/json',
    'Accept-Language': navigator.language,
    'x-api-key': `${process.env.VUE_APP_API_KEY}`
  }
});

/**
 * Intercept all API requests
 */
api.interceptors.request.use((config) => {
  const configWithHeaders = config;
  return configWithHeaders;
});

export default api;
